const pattern = new RegExp(/(username|userid).+(;|\))/, 'gi');
export const cleanseUserAgent = useragent => {
  return useragent.replaceAll(pattern, '');
};
